import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import Article from 'src/smoothr-web-app-core/models/Article';
import Order from 'src/smoothr-web-app-core/models/Order';
import { numberToCurrency, sleep } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-selection-product-from-free-article',
	templateUrl: './selection-product-from-free-article.component.html',
	styleUrls: ['./selection-product-from-free-article.component.scss'],
})
export class SelectionProductFromFreeArticleComponent implements OnInit {
	public selectedArticles: Article | null;
	articlesList: Article[];
	order: Order;
	numberToCurrency = numberToCurrency;
	constructor(
		private modalCtrl: ModalController,
		private translate: TranslateService,
		private cdr: ChangeDetectorRef
	) {}

	static async show(modalCtrl: ModalController, articlesList: Article[], order: Order): Promise<Article> {
		const modal = await modalCtrl.create({
			component: SelectionProductFromFreeArticleComponent,
			cssClass: ['auto-height, recommendation-dialog'],
			componentProps: {
				articlesList,
				order,
			},
			showBackdrop: true,
		});
		await modal.present();
		await sleep(100);
		return (await modal.onDidDismiss()).data;
	}
	ngOnInit() {}
	trackBy(index: number, article: Article) {
		return article._id;
	}
	dismiss() {
		this.modalCtrl.dismiss();
	}
	selectArticle(article: Article) {
		this.selectedArticles = article;
	}
	showAmount(article: Article) {
		return article._id === this.selectedArticles?._id ? 1 : 0;
	}

	addArticlesToBasket() {
		this.modalCtrl.dismiss(this.selectedArticles);
	}
}
